<template>
  <div v-if="postulaciones.length > 0">
    <div
      class="gilmer text-uppercase text-azul h4 font-weight-bold px-3 px-lg-0 pt-3 pt-lg-0"
    >
      {{ titulo }}
    </div>
    <div class="text-black-50 px-3 px-lg-0 h6">
      {{ texto1 }}
      <strong>{{ destacado }}</strong>
      {{ texto2 }}
    </div>
    <div class="px-3 px-lg-0 mt-4">
      <ItemPostulacion
        v-for="postulacion in postulaciones"
        :key="postulacion.idPostulacion"
        :postulacion="postulacion"
      />
    </div>
  </div>
</template>

<script>
import ItemPostulacion from "@/components/postulante/ItemPostulacion";
export default {
  components: {
    ItemPostulacion
  },
  props: ["postulaciones", "texto1", "destacado", "texto2", "titulo"]
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/postulante/SeccionPostulacion.vue